module.exports = __webpack_public_path__ + "static/media/IMG-22.50cc1c9b.jpg";